// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import VillageLogin from './pages/VillageLogin';
import VillageDashboard from './pages/VillageDashboard';
import './index.css'; // Use the main CSS file

function Home() {
  return (
    <div className="home-container">
      <div className="hero-section">
        <div className="hero-content">
          <h1>🐄 Dairy Manager</h1>
          <p className="hero-subtitle">Efficient milk collection and management system</p>
          
          <div className="cta-buttons">
            <Link to="/village-login" className="btn btn-secondary">
              🐄 Village Login
            </Link>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Real-time Tracking</h3>
              <p>Monitor milk collection in real-time</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👨‍🌾</div>
              <h3>Farmer Management</h3>
              <p>Manage farmers and their collections</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Daily Reports</h3>
              <p>Generate comprehensive daily reports</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/village-login" element={<VillageLogin />} />
        <Route path="/dashboard/:villageCode" element={<VillageDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
